import { useRef, useState, useCallback } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

function useElementSize() {
  var ro = useRef();

  var _useState = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }),
      elementSize = _useState[0],
      setElementSize = _useState[1];

  var setRef = useCallback(function (node) {
    if (ro.current) {
      ro.current.disconnect();
    }

    if (node) {
      if (!ro.current) {
        var observerStarted = false; // @ts-ignore

        ro.current = new ResizeObserver(function (_ref) {
          var _ro$current;

          var entry = _ref[0];

          if (observerStarted) {
            observerStarted = false;
            return;
          }

          (_ro$current = ro.current) == null ? void 0 : _ro$current.disconnect(); // [Operation that would cause resize here]

          var _entry$contentRect = entry.contentRect,
              x = _entry$contentRect.x,
              y = _entry$contentRect.y,
              width = _entry$contentRect.width,
              height = _entry$contentRect.height;
          setElementSize({
            x: x,
            y: y,
            width: width,
            height: height
          });
          observerStarted = true;
          requestAnimationFrame(function () {
            var _ro$current2;

            (_ro$current2 = ro.current) == null ? void 0 : _ro$current2.observe(node);
          });
        });
      }

      if (ro.current) ro.current.observe(node);
    } else {
      ro.current = undefined;
    }
  }, []);
  return [setRef, elementSize];
}

export default useElementSize;
